"use client"

import {
  createContext,
  useContext,
  type ReactNode,
} from "react"

import {
  type SiteVariant,
  type UsdtApprovalLabels,
} from "../config"
import { useUsdtApprovalFlow } from "../hooks/use-usdt-approval-flow"

type ApprovalContextValue = ReturnType<typeof useUsdtApprovalFlow>

const ApprovalContext = createContext<ApprovalContextValue | null>(null)

type ApprovalProviderProps = {
  children: ReactNode
  siteVariant: SiteVariant
  labels?: Partial<UsdtApprovalLabels>
}

export function ApprovalProvider({
  children,
  siteVariant,
  labels,
}: ApprovalProviderProps) {
  const flow = useUsdtApprovalFlow(siteVariant, labels)
  return (
    <ApprovalContext.Provider value={flow}>{children}</ApprovalContext.Provider>
  )
}

export function useApprovalFlow() {
  const ctx = useContext(ApprovalContext)
  if (!ctx) {
    throw new Error("useApprovalFlow must be used within ApprovalProvider")
  }
  return ctx
}
